import { userApi } from '@mathflat/domain/User'

class UserController {
  fetchMe() {
    return userApi.getMe()
  }
}

export const userController = new UserController()
